import { BUSINESS_HOURS } from '../model/types'
import { TimeSlot } from './TimeSlot'

interface DayColumnProps {
    date: string // yyyy-MM-dd
    dayName: string
    dayNumber: string
    isWeekView?: boolean
    showHourOnly?: boolean
}

const timeSlots = Array.from({ length: BUSINESS_HOURS.end - BUSINESS_HOURS.start }, (_, i) => {
    const hour = BUSINESS_HOURS.start + i
    return `${String(hour).padStart(2, '0')}:00`
})

export function DayColumn({ date, dayName, dayNumber, isWeekView = false, showHourOnly = false }: DayColumnProps) {
    return (
        <div className='relative grid auto-rows-[6rem]'>
            {/* Header for week view */}
            {isWeekView && (
                <div className='border-b border-r p-2 text-center'>
                    <div className='font-medium capitalize'>{dayName}</div>
                    <div className='text-sm text-muted-foreground'>{dayNumber}</div>
                </div>
            )}
            {/* Time slots */}
            {timeSlots.map(time => (
                <TimeSlot
                    key={`${date}-${time}`}
                    time={time}
                    date={date}
                    isWeekView={isWeekView}
                    showHour={showHourOnly}
                />
            ))}
        </div>
    )
}
